import type { SVGProps } from 'react';

export default function MonitorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='black' strokeWidth='1.5' {...props}>
      <rect x='2.5' y='3.33325' width='15' height='9.16667' rx='1' />
      <path d='M9.99984 12.5V16.6667M9.99984 16.6667H13.3332M9.99984 16.6667H6.6665' strokeLinecap='round' />
    </svg>
  );
}

MonitorIcon.displayName = 'MonitorIcon';
